export const homeModalSessionInfo = {
  homeModalSessionInfotitle: "¡Bienvenido de nuevo!",
  homeModalSessionInfotitleCurrentBalance: "Saldo actual",
  homeModalSessionInfoLastConnection: "Último acceso",
  homeModalSessionInfoLastConnectionAtTime: "a las",
  homeModalSessionInfoLowBalanceWarning: "Tu saldo es bajo. ¿Te gustaría depositar más dinero?",
  homeModalSessionInfoGoToDeposit: "Depositar",
  homeModalSessionInfoContinue: "Continuar",
  homeModalSessionInfoDeposit: "¿Te gustaría depositar más dinero?",
  homeModalSessionInfoAtTime: "a las ",
};
